var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-md" },
    [
      _c(_vm.brandComponent, { tag: "component" }),
      _c("menu-toggler", { attrs: { toggleID: _vm.toggleID } }),
      _c(_vm.linksComponent, {
        tag: "component",
        attrs: { toggleID: _vm.label + "Links" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }